import ClientsContainer from './containers/ClientsContainer';
export default ClientsContainer;
